module.exports = __webpack_public_path__ + "img/terrific-logo-sharing.f535c30c.png";